import { routes } from "consts";
import React from "react";
import { useNavigate } from "react-router-dom";

import { useToaster } from "utils";
import { HeaderWithBreadcrumbs, PageMain } from "components/molecules";
import { ExamForm, ExamFormValues } from "./ExamForm";
import { examsApi } from "api/examsApi";

export const ExamCreatePage = () => {
  const navigate = useNavigate();
  const { showSuccess, showError } = useToaster();

  const breadcrumbs = [{ title: "Egzaminy", path: routes.EXAMS }, { title: "Dodawanie egzaminu" }];

  const onSubmit = async (data: ExamFormValues) => {
    try {
      await examsApi.create(data);
      navigate(routes.EXAMS);
      showSuccess("Egzamin została dodany.");
    } catch (e) {
      console.error(e);
      showError("Nie udało się dodać egzaminu.");
    }
  };

  return (
    <PageMain>
      <HeaderWithBreadcrumbs breadcrumbs={breadcrumbs} headerText="Dodaj nowy egzamin" />
      <ExamForm onSubmit={onSubmit} />
    </PageMain>
  );
};
